
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/keyboard.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-plugins-keyboard-demo-plugin-keyboard"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/keyboard.en.md?type=demo')
};